import PropTypes from "prop-types";

/**
 * Displays a simple information message string.
 *
 * @param root0 - The component props.
 * @param root0.message - The information message to display.
 * @returns The rendered information message component.
 */
const InformationMessage = ({ message }) => {
    return <div className="information-message">{message}</div>;
};

InformationMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default InformationMessage;
